import { PlayerColor, TradeResponseStatus } from '@colonist/game-states';
import { PlayerValidator } from './PlayerValidator.ts';
import { CurrentStateValidator } from './CurrentStateValidator.ts';
import { MapValidator } from './map/MapValidator.ts';
export class GameValidator {
    getPlayerValidator(color) {
        const playerValidator = this.playerValidators.get(color);
        if (playerValidator == undefined) throw new Error(`PlayerValidator for color ${PlayerColor[color]} not found`);
        return playerValidator;
    }
    getPlayersTakingAction() {
        const playersTakingOutOfTurnAction = [];
        for (const player of this.playerValidators.values()){
            if (!this.isPlayerTakingOutOfTurnAction(player.color)) continue;
            playersTakingOutOfTurnAction.push(player.color);
        }
        if (playersTakingOutOfTurnAction.length == 0) return this.currentStateValidator.currentTurnPlayers;
        return playersTakingOutOfTurnAction;
    }
    isPlayerTakingOutOfTurnAction(player) {
        const playerState = this.gameState.playerStates[player];
        if (playerState === undefined) return false;
        if (playerState.isTakingAction) return true;
        const isWaitingForOpponentTradeResponses = Object.keys(this.gameState.tradeState.activeOffers).length > 0 && this.currentStateValidator.currentTurnPlayers.includes(player);
        if (isWaitingForOpponentTradeResponses) return true;
        for (const activeTradeState of Object.values(this.gameState.tradeState.activeOffers)){
            if (activeTradeState == undefined) continue;
            if (activeTradeState.playersCreatingCounterOffer[player] == true) return true;
            if (activeTradeState.playerResponses[player] == TradeResponseStatus.PendingResponse) return true;
        }
        return false;
    }
    constructor(gameState, userStates){
        var _gameState_experimentalMechanicState, _gameState_experimentalMechanicState1, _gameState_experimentalMechanicState2, _gameState_experimentalMechanicState3;
        this.playerValidators = new Map();
        this.gameState = gameState;
        this.userStates = userStates;
        this.mapValidator = new MapValidator(gameState.mapState);
        const experimentalCurrentState = (_gameState_experimentalMechanicState = gameState.experimentalMechanicState) === null || _gameState_experimentalMechanicState === void 0 ? void 0 : _gameState_experimentalMechanicState.currentState;
        const mechanicTurnColonistRushState = (_gameState_experimentalMechanicState1 = gameState.experimentalMechanicState) === null || _gameState_experimentalMechanicState1 === void 0 ? void 0 : _gameState_experimentalMechanicState1.mechanicTurnColonistRushState;
        const mechanicRobberColonistRushState = (_gameState_experimentalMechanicState2 = gameState.experimentalMechanicState) === null || _gameState_experimentalMechanicState2 === void 0 ? void 0 : _gameState_experimentalMechanicState2.mechanicRobberColonistRushState;
        const playerStates = (_gameState_experimentalMechanicState3 = gameState.experimentalMechanicState) === null || _gameState_experimentalMechanicState3 === void 0 ? void 0 : _gameState_experimentalMechanicState3.playerStates;
        const playerColorKeys = Array.from(this.playerValidators.keys());
        this.currentStateValidator = new CurrentStateValidator(gameState.currentState, experimentalCurrentState, mechanicTurnColonistRushState, playerStates, playerColorKeys, mechanicRobberColonistRushState);
        for(const playerColorKey in this.gameState.playerStates){
            const playerColor = Number(playerColorKey);
            const playerState = this.gameState.playerStates[playerColor];
            if (playerState == undefined) continue;
            const userState = this.userStates.find((playerUserState)=>playerUserState.selectedColor === playerColor);
            if (userState == undefined) continue;
            const playerStateController = new PlayerValidator(playerState, userState);
            this.playerValidators.set(playerStateController.color, playerStateController);
        }
    }
}
